import type { LucideIcon } from "lucide-react";
import { cn, generateUUID } from "@drpcrd/utils";
import { colors } from "../../styles/colors";

export type GradientIconProps = {
  icon: LucideIcon;
  size?: number;
  className?: string;
};

/**
 * A reusable component that applies a linear gradient effect to Lucide icons
 */
export const GradientIcon = ({
  icon: Icon,
  size = 16,
  className,
}: GradientIconProps) => {
  const gradientId = generateUUID();

  return (
    <div className={cn("relative inline-flex", className)} aria-hidden>
      {/* Hidden defs container so the gradient can be referenced by subsequent SVGs */}
      <svg
        width="0"
        height="0"
        className="absolute"
        aria-hidden
        focusable="false"
      >
        <defs>
          <linearGradient
            id={gradientId}
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor={colors.primary} />
            <stop offset="100%" stopColor={colors.pink500} />
          </linearGradient>
        </defs>
      </svg>
      {/* lucide icons set stroke="currentColor"; we override stroke directly to use the gradient */}
      <Icon size={size} stroke={`url(#${gradientId})`} />
    </div>
  );
};
